// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  castToBool,
  castToFloat,
} from 'helpers/reduxFormFunctions'

const formatFilterForAPI = v => {
  const environmentPathMarginDb = castToFloat(v.environmentPathMarginDb)
  const proposedPathMarginDb = castToFloat(v.proposedPathMarginDb)
  const buckDistanceKm = castToFloat(v.buckDistanceKm)

  const ignoredContactIds = v.ignoredContacts.map(d => d.contactId)
  const ignoredSegmentStatuses = v.ignoredSegmentStatuses.map(d => d.segmentStatusId)
  const ignoredPathIds = v.ignoredPaths.map(d => d.pathId)

  // don't send any whitespace in the request.
  const ignoredTerrCases = v.ignoredTerrCases.replace(/[\n\r\s\t]+?/g, '') || null

  const ignorePreviousPathFlag = castToBool(v.ignorePreviousPathFlag)
  const secondaryFlag = castToBool(v.secondaryFlag)
  const s10AccpFlag = castToBool(v.s10AccpFlag)
  const s10AcapFlag = castToBool(v.s10AcapFlag)
  const s10DeltaFFlag = castToBool(v.s10DeltaFFlag)

  const afsProtectionTypeId = castToFloat(v.afsProtectionTypeId)

  return {
    afsProtectionTypeId,
    buckDistanceKm,
    environmentPathMarginDb,
    ignoredContactIds,
    ignoredSegmentStatuses,
    ignoredPathIds,
    ignoredTerrCases,
    ignorePreviousPathFlag,
    proposedPathMarginDb,
    s10AcapFlag,
    s10AccpFlag,
    s10DeltaFFlag,
    secondaryFlag,
  }
}

export default formatFilterForAPI
